/**
 * @flow
 * @relayHash ebe54b98074edfbc8562978c635f7178
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateOrCreateUserInput = {
  update: UpdateUser,
  create: CreateUser,
  clientMutationId: string,
};
export type UpdateUser = {
  active?: ?boolean,
  email?: ?string,
  id: string,
  name?: ?string,
};
export type CreateUser = {
  active?: ?boolean,
  email: string,
  name: string,
};
export type CreateUserMutationVariables = {|
  input: UpdateOrCreateUserInput
|};
export type CreateUserMutationResponse = {|
  +updateOrCreateUser: ?{|
    +edge: ?{|
      +node: {|
        +name: string,
        +email: string,
        +active: boolean,
        +id: string,
      |},
      +cursor: string,
    |}
  |}
|};
*/


/*
mutation CreateUserMutation(
  $input: UpdateOrCreateUserInput!
) {
  updateOrCreateUser(input: $input) {
    edge {
      node {
        name
        email
        active
        id
      }
      cursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateOrCreateUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateOrCreateUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateOrCreateUserInput!"
      }
    ],
    "concreteType": "UpdateOrCreateUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edge",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CreateUserMutation",
  "id": null,
  "text": "mutation CreateUserMutation(\n  $input: UpdateOrCreateUserInput!\n) {\n  updateOrCreateUser(input: $input) {\n    edge {\n      node {\n        name\n        email\n        active\n        id\n      }\n      cursor\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CreateUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0023e1705e05b0eb20cd9de4222cf007';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/CreateUserMutation.graphql.js